import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IsStepperProps, Stepper } from '../styled/stepper/Stepper'
import { ReduxState } from '../../store/reducers'
import { updateRoomsNumber } from '../../store/lead/leadSlice'
import { setDefaultRoomsBasedOnLivingSpace } from '../../store/lead/thunks'

export const MIN_ROOM = 1
export const MAX_ROOM = 50

export const isValidRoomsNumber = (numberOfRooms?: number): boolean =>
  numberOfRooms ? numberOfRooms >= MIN_ROOM && numberOfRooms <= MAX_ROOM : false

interface RoomsStepperProps {
  onChange?: (value?: number) => void
  className?: string
}

const RoomsStepper = ({ onChange, className }: RoomsStepperProps) => {
  const { rooms: numberOfRooms } = useSelector((state: ReduxState) => state.lead)
  const { theme } = useSelector((state: ReduxState) => state.config)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setDefaultRoomsBasedOnLivingSpace())
  }, [dispatch])

  const roomsNumberChanged = (event: React.ChangeEvent<IsStepperProps>): void => {
    const newValue = parseInt(event.target.value.toString().slice(0, 2))
    dispatch(updateRoomsNumber(newValue))
    if (typeof onChange === 'function') onChange(newValue)
  }

  return (
    <div className='grid-flex grid-justify-center'>
      <div className={`grid-item one-whole align-left ${className}`}>
        <Stepper
          id='room-stepper'
          data-testing='rooms-input'
          label='Zimmer'
          min={MIN_ROOM}
          max={MAX_ROOM}
          maxLength={2}
          step={1}
          value={numberOfRooms}
          onChange={roomsNumberChanged}
          valid={isValidRoomsNumber(numberOfRooms)}
          textColor={theme.text}
          borderColor={theme.secondary}
          backgroundColor={theme.background}
          className={'input-text'}
        />
      </div>
    </div>
  )
}

export default RoomsStepper
